export enum UserRole {
  Manager = 'sales_manager_group',
  SalesPerson = 'sales_person_group',
  SuperUser = 'admin_group',
  ReadOnly = 'read_only_group',
}